import { commissionAdvanceHelp } from '@hue/contracts';
import { Button, HelpTip, formatCurrency } from '@hue/design-system';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { CommissionAdvanceDialog } from '../../app/commission-advance-dialog.js';
import { commissionsApi } from '../../lib/api.js';

/// Vales em aberto na ficha do profissional (ADR 0082, decisão 24).
export function ProfessionalAdvances({
  resource,
  today,
}: {
  resource: { id: string; displayName: string };
  today: string;
}) {
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const key = ['company', 'commissions', 'advances'];
  const advances = useQuery({ queryKey: key, queryFn: commissionsApi.advances, retry: false });
  const openCents = (advances.data ?? [])
    .filter((one) => one.resourceId === resource.id)
    .reduce((sum, one) => sum + one.amountCents - one.appliedCents, 0);
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 sm:col-span-2">
      <p className="text-sm">
        Vales em aberto: <strong>{formatCurrency(openCents, 'BRL')}</strong>
      </p>
      <span className="flex items-center gap-1">
        <Button type="button" variant="outline" onClick={() => setOpen(true)}>
          Registrar vale
        </Button>
        <HelpTip label="Ajuda: o que é o vale" content={commissionAdvanceHelp} />
      </span>
      {open ? (
        <CommissionAdvanceDialog
          resource={resource}
          today={today}
          onClose={() => setOpen(false)}
          onSaved={() => queryClient.invalidateQueries({ queryKey: ['company', 'commissions'] })}
        />
      ) : null}
    </div>
  );
}
